import { render } from "./UserBetStats.vue?vue&type=template&id=744ace30&scoped=true"
import script from "./UserBetStats.vue?vue&type=script&lang=js"
export * from "./UserBetStats.vue?vue&type=script&lang=js"

import "./UserBetStats.vue?vue&type=style&index=0&id=744ace30&scoped=true&lang=css"

import exportComponent from "/vercel/path0/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-744ace30"]])

export default __exports__